import { get } from "lodash-es";
import moment from "moment";
import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { Log } from "../models/Log";
import { TagFilterType } from "../models/Tag";

type Props = {
	startDate: Date;
	endDate: Date | null;
	logTypeCode: number | string | null;
	tagFilters?: TagFilterType[];
};

//fx obtener logs
export const getLogs = async (params: Props, signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	const end = params.endDate ? params.endDate : tomorrow;

	const tagFiltersJson =
		params.tagFilters && params.tagFilters.length > 0
			? JSON.stringify(params.tagFilters)
			: null;

	const parameters: spParameter[] = [
		{ name: "Start", value: params.startDate },
		{ name: "End", value: end },
		{
			name: "LogTypeCode",
			value: params.logTypeCode === "A" ? null : params.logTypeCode,
		},
		{ name: "TagFilters", value: tagFiltersJson },
	];

	const resp = await apiService.callV2("[MES].[GetLogs]", parameters, signal);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []);

		rows = rows.map((log: Log) => ({
			...log,
			Timestamp: log.Timestamp ? moment.utc(log["Timestamp"]).toDate() : null,
		}));

		return rows as Log[];
	} else {
		throw new Error(resp.message || "Error fetching logs");
	}
};
